// src/components/pages/SchedulePage.jsx
import React from 'react';
import QuickActions from '../schedule/QuickActions';
import ScheduleList from '../schedule/ScheduleList';
import '../../styles/schedule.css';

const SchedulePage = () => {
  return (
    <div className="schedule-page">
      {/* Page header */}
      <div className="schedule-page-header">
        <h1 className="schedule-page-title">Schedule &amp; Quick Actions</h1>
        <p className="schedule-page-sub">
          Trigger syncs manually or configure automated cron schedules
        </p>
      </div>

      {/* Row 1 — Quick Actions */}
      <QuickActions />

      {/* Row 2 — Scheduled Syncs */}
      <ScheduleList />
    </div>
  );
};

export default SchedulePage;
